import {
  getItemFromCollection,
  getItemsFromCollection,
} from "directus/src/operations";

export async function fetchCaseStudyContext(
  casestudyId,
  fields = [
    "id",
    "project.id",
    "project.project_id",
    "project.coordinator",
    "project.sales_coordinator",
    "project.account_manager",
  ],
) {
  try {
    const query = {
      fields,
    };
    const response = await getItemFromCollection(
      "case_studies",
      casestudyId,
      query,
    );
    return response;
  } catch (error) {
    console.error("Error fetching case study context:", error);
    throw error;
  }
}

export async function fetchProjectCoordinator(
  project_id,
  fields = ["coordinator", "sales_coordinator", "account_manager"],
) {
  try {
    const query = {
      fields,
      filter: {
        project_id: {
          _eq: project_id,
        },
      },
    };
    const response = await getItemsFromCollection("projects", query);
    return response[0];
  } catch (error) {
    console.error("Error fetching project coordinators:", error);
    throw error;
  }
}

export async function fetchProjectAccountManager(
  project_id,
  fields = ["account_manager"],
) {
  try {
    const query = {
      fields,
      filter: {
        project_id: {
          _eq: project_id,
        },
      },
    };
    const response = await getItemsFromCollection("projects", query);
    return response[0];
  } catch (error) {
    console.error("Error fetching project account manager:", error);
    throw error;
  }
}

export async function fetchJobCoordinator(jobId, fields = ["coordinator"]) {
  try {
    const query = {
      fields,
    };
    const response = await getItemFromCollection("jobs", jobId, query);
    return response;
  } catch (error) {
    console.error("Error fetching job coordinator:", error);
    throw error;
  }
}

export async function fetchJobCoordinatorsByProject(
  project_id,
  fields = ["coordinator"],
) {
  try {
    const query = {
      fields,
      filter: {
        project: {
          project_id: {
            _eq: project_id,
          },
        },
      },
    };
    const response = await getItemsFromCollection("jobs", query);
    return response;
  } catch (error) {
    console.error("Error fetching job coordinators by project:", error);
    throw error;
  }
}
export async function fetchMilestoneCoordinator(
  milestoneId,
  fields = ["coordinator"],
) {
  try {
    const query = {
      fields,
    };
    const response = await getItemFromCollection(
      "milestones",
      milestoneId,
      query,
    );
    return response;
  } catch (error) {
    console.error("Error fetching milestone coordinator:", error);
    throw error;
  }
}

// Fetch billable with nested job and project to derive coordinators via billable
export async function fetchBillableContext(
  billableId,
  fields = [
    "id",
    "job.id",
    "job.coordinator",
    "job.project.id",
    "job.project.coordinator",
    "job.project.sales_coordinator",
    "job.project.account_manager",
  ],
) {
  try {
    const query = {
      fields,
    };
    const response = await getItemFromCollection(
      "billables",
      billableId,
      query,
    );
    return response;
  } catch (error) {
    console.error("Error fetching billable context:", error);
    throw error;
  }
}

export async function fetchJobContext(
  jobId,
  fields = [
    "id",
    "coordinator",
    "project.id",
    "project.coordinator",
    "project.sales_coordinator",
    "project.account_manager",
  ],
) {
  try {
    const query = {
      fields,
    };
    const response = await getItemFromCollection("jobs", jobId, query);
    return response;
  } catch (error) {
    console.error("Error fetching job context:", error);
    throw error;
  }
}

// Fetch milestone with nested job and project to derive coordinators via milestone
export async function fetchMilestoneContext(
  milestoneId,
  fields = [
    "id",
    "coordinator",
    "job.id",
    "job.coordinator",
    "job.project.id",
    "job.project.coordinator",
    "job.project.sales_coordinator",
    "job.project.account_manager",
  ],
) {
  try {
    const query = {
      fields,
    };
    const response = await getItemFromCollection(
      "milestones",
      milestoneId,
      query,
    );
    return response;
  } catch (error) {
    console.error("Error fetching milestone context:", error);
    throw error;
  }
}
